import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Image as ChakraImage, Text } from '@chakra-ui/react';
import { Button, Carousel, Expand, Icon, MobileCarousel, ModalVariants } from '@whitbread-eos/atoms';
import { formatAssetsUrl, isStringValid, akamaiImageLoader, isIVMEnabled } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelRoomImagesComponent(_ref) {
  var _images, _images$imageSrc, _images2, _images$alt, _images3;
  var images = _ref.images,
    thumbnailHeight = _ref.thumbnailHeight,
    isLessThanSm = _ref.isLessThanSm,
    isLessThanLg = _ref.isLessThanLg,
    containerRef = _ref.containerRef;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeThumbnail = _useState4[0],
    setActiveThumbnail = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeSlide = _useState6[0],
    setActiveSlide = _useState6[1];
  var isInContainer = !!containerRef;
  var thumbnailStyles = {
    position: 'relative',
    h: thumbnailHeight,
    w: '100%'
  };
  return _jsxs(Box, {
    "data-testid": "room-images",
    children: [_jsxs(Box, _objectSpread(_objectSpread({}, thumbnailStyles), {}, {
      children: [isStringValid(images === null || images === void 0 || (_images = images[(images === null || images === void 0 ? void 0 : images.length) - 1]) === null || _images === void 0 ? void 0 : _images.imageSrc) && _jsx(Image, {
        src: formatAssetsUrl((_images$imageSrc = images === null || images === void 0 || (_images2 = images[(images === null || images === void 0 ? void 0 : images.length) - 1]) === null || _images2 === void 0 ? void 0 : _images2.imageSrc) !== null && _images$imageSrc !== void 0 ? _images$imageSrc : ''),
        alt: (_images$alt = images === null || images === void 0 || (_images3 = images[images.length - 1]) === null || _images3 === void 0 ? void 0 : _images3.alt) !== null && _images$alt !== void 0 ? _images$alt : '',
        fill: true,
        style: {
          objectFit: 'cover',
          objectPosition: 'center'
        },
        priority: false,
        loader: isIVMEnabled() ? akamaiImageLoader : undefined,
        sizes: "640px"
      }), images && (images === null || images === void 0 ? void 0 : images.length) > 1 && renderCTAButton()]
    })), renderModal()]
  });
  function renderCTAButton() {
    var CTAButtonStyles = {
      position: 'absolute',
      bottom: 'sm',
      right: 'sm',
      width: 'auto',
      height: 'var(--chakra-space-xl)',
      fontSize: 'sm'
    };
    var CTAIconStyles = {
      position: 'absolute',
      top: 'sm',
      right: 'sm',
      width: 'var(--chakra-space-xl)',
      height: 'var(--chakra-space-xl)',
      cursor: 'pointer'
    };
    if (isLessThanLg) {
      return _jsx(Box, _objectSpread(_objectSpread({}, CTAIconStyles), {}, {
        "data-testid": "room-images__expand",
        onClick: () => {
          setActiveThumbnail(0);
          setIsModalVisible(true);
          setActiveSlide(0);
        },
        children: _jsx(Expand, {})
      }));
    } else {
      return _jsx(Button, _objectSpread(_objectSpread({
        variant: "tertiary",
        size: "sm",
        "data-testid": "hdp_roomsViewGallery"
      }, CTAButtonStyles), {}, {
        onClick: () => {
          setActiveThumbnail(0);
          setIsModalVisible(true);
          setActiveSlide(0);
        },
        children: t('hoteldetails.viewgallery')
      }));
    }
  }
  function renderModal() {
    var mobileGalleryThumbnails = images === null || images === void 0 ? void 0 : images.map(item => {
      var _item$thumbnailSrc, _item$alt;
      return _jsx(ChakraImage, {
        src: formatAssetsUrl((_item$thumbnailSrc = item === null || item === void 0 ? void 0 : item.thumbnailSrc) !== null && _item$thumbnailSrc !== void 0 ? _item$thumbnailSrc : ''),
        alt: (_item$alt = item === null || item === void 0 ? void 0 : item.alt) !== null && _item$alt !== void 0 ? _item$alt : ''
      }, item === null || item === void 0 ? void 0 : item.alt);
    });
    var sizes = isLessThanLg ? undefined : '640px';
    var imageCarousel = renderImages(sizes);
    return _jsx(ModalVariants, _objectSpread(_objectSpread({
      isOpen: isModalVisible,
      onClose: () => {
        setIsModalVisible(false);
        setActiveThumbnail(0);
        setActiveSlide(0);
      },
      variant: "gallery",
      variantProps: {
        title: "".concat(activeSlide + 1, "/").concat(imageCarousel === null || imageCarousel === void 0 ? void 0 : imageCarousel.length)
      }
    }, containerRef && {
      portalProps: {
        containerRef
      }
    }), {}, {
      children: isLessThanLg ? _jsx(MobileCarousel, {
        activeSlide: activeSlide,
        setActiveSlide: setActiveSlide,
        thumbnails: mobileGalleryThumbnails,
        children: imageCarousel
      }, activeThumbnail) : _jsx(Box, {
        w: isInContainer ? '100%' : '41.875rem',
        px: isInContainer ? {
          mobile: '1rem',
          sm: '4xl'
        } : '4xl',
        children: _jsx(Carousel, {
          activeSlide: activeSlide,
          setActiveSlide: setActiveSlide,
          children: imageCarousel
        }, activeThumbnail)
      })
    }));
  }
  function renderImages(sizes) {
    var iconStyles = isLessThanSm ? {
      position: 'absolute',
      left: 'sm',
      bottom: '6xl',
      bgColor: 'baseWhite',
      borderRadius: '4px',
      p: '6px 6px 6px 8px'
    } : {
      mr: 'sm'
    };
    var iconFlexStyles = {
      minH: '4rem',
      alignItems: 'center',
      justify: 'center',
      position: 'relative'
    };
    return images === null || images === void 0 ? void 0 : images.map(item => {
      var _item$imageSrc;
      return _jsxs(Box, {
        children: [_jsx(Box, {
          position: "relative",
          w: "full",
          h: {
            sm: '25.313rem',
            xs: '18.938rem',
            mobile: '11.25rem',
            base: '11.25rem'
          },
          children: _jsx(Image, {
            src: formatAssetsUrl((_item$imageSrc = item === null || item === void 0 ? void 0 : item.imageSrc) !== null && _item$imageSrc !== void 0 ? _item$imageSrc : ''),
            alt: "Hotel Image",
            fill: true,
            sizes: sizes,
            style: {
              objectFit: 'cover'
            },
            loader: isIVMEnabled() ? akamaiImageLoader : undefined
          })
        }), _jsxs(Flex, _objectSpread(_objectSpread({}, iconFlexStyles), {}, {
          "data-testid": "carousel_room-image-caption",
          children: [(item === null || item === void 0 ? void 0 : item.iconSrc) && _jsx(Icon, _objectSpread({
            src: formatAssetsUrl(item.iconSrc)
          }, iconStyles)), _jsx(Text, {
            children: item === null || item === void 0 ? void 0 : item.caption
          })]
        }))]
      }, item === null || item === void 0 ? void 0 : item.alt);
    });
  }
}